import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import Layout from "./common/Layout";
import Back from "./common/Back";
import { useApi } from "../store/hooks";
import Loader from "./common/Loader";

const OpenbankingStart = () => {
  const { t, i18n } = useTranslation();
  const { openbankingStart } = useApi();

  useEffect(() => {
    const initiateOpenBanking = async () => {
      const response = await openbankingStart();
      const redirectUrl = response.redirectUrl;
      window.location.replace(redirectUrl);
    };
    initiateOpenBanking();
  }, []);

  return (
    <Layout>
      <div className="az-title">{t("openbankingStart.title")}</div>

      <Loader
        loading={true}
        title={t("initial.loader.title")}
        message={t("openbankingStart.loading.message")}
      />

      <Back message={t("back.label")} />
    </Layout>
  );
};

export default OpenbankingStart;
